import React from "react";
import { Modal, Box, Typography, Button, IconButton, Link } from "@mui/material";
import Grid from "@mui/material/Grid";
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';

import {privacyPracticeUrl} from "../../../constants/Config";
import { ContentBoxHeader, CreateBtn, IconButtonStyles, TypographyStyles, ModalGrid, ModalGridContainer, IconStyle } from "../styles/SecurityModal";
import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

interface PrivacyModalProps {
    openModal: boolean;
    closeModal: (onClose: boolean) => void;
    setIsDisagree: (onClose: boolean) => void;
    setIsChecked: (onClose: boolean) => void;
}

const PrivacyModal: React.FC<PrivacyModalProps> = ({ openModal, closeModal, setIsDisagree, setIsChecked }) => {

    const handleClick = () => {
        closeModal(false);
        setIsDisagree(false);
        setIsChecked(true)
    }

    const handleDisagree = () => {
        closeModal(false);
        setIsDisagree(true)
        setIsChecked(false)
    }

    return (
        <Modal
            open={openModal}
            onClose={closeModal}
            aria-labelledby="privacy-modal-title"
            aria-describedby="modal-modal-description"
            sx={ModalGridContainer}
        >
            <Box sx={ModalGrid}>
                <Grid container>
                    <Grid size={12} sx={IconButtonStyles}>
                        <IconButton
                            onClick={handleDisagree}
                            sx={IconStyle}
                        >
                            <HighlightOffOutlinedIcon color="primary" fontSize="small" />
                        </IconButton>
                    </Grid>
                    <Grid size={12}>
                    <Typography
                        variant="h3"
                        color={colors.fonts[20]}
                        fontWeight={fontWeight.Weight[7]}
                        sx={TypographyStyles}
                    >
                        Privacy and Security
                        </Typography>
                    </Grid>
                    <Typography
                        variant="body1"
                        fontWeight={fontWeight.Weight[2]}
                        color={colors.fonts[25]}
                        mb={"1rem"}
                    >
                        tango is committed to maintaining the confidentiality, privacy and security of its
                        patients protected health information Consistent with the Health Insurance Portability
                        and Accountability Act (HIPAA), we do not use, disclose or discuss patient specific
                        information with others unless it is necessary to serve the patient or required by law. A
                        copy of our Notice of Privacy Practices is provided here. The notice describes how
                        protected health information may be used and disclosed and how to access PHI.
                    </Typography>
                    <Typography
                        variant="body1"
                        fontWeight={fontWeight.Weight[3]}
                        color={colors.fonts[25]}
                        mb={"1.5rem"}
                        >
                        We are committed to being conscientious and accountable when handling confidential
                        company information. In addition, because of its confidential nature, business and
                        health information must be protected by an effective internal control environment,
                        including policies and procedures to secure the companys assets, and made available
                        outside the company only with appropriate authorization and after consideration of the
                        interests of tango as a whole.
                    </Typography>
                    <Typography
                        variant="h3"
                        color={colors.fonts[20]}
                        fontWeight={fontWeight.Weight[7]}
                        mb={"0.3rem"}
                    >
                        Website Content
                    </Typography>
                    <Typography
                        variant="body1"
                        fontWeight={fontWeight.Weight[3]}
                        color={colors.fonts[25]}
                        sx={{ mb: 2 }}>
                        tango may change, add or remove some or all of the Content on this website at any
                        time. In addition, please note that although our goal is to provide accurate information,
                        certain features that may be offered through this website, such as participating
                        healthcare providers information or other Content, may not be accurate or up to date. In
                        addition please note that features of any plan or plans described in this website may
                        change over time as permitted by law, including benefit levels, items included in any
                        formulary, pricing or lists of participating providers or other associated vendors.
                    </Typography>
                    <Typography
                    variant="body1"
                    fontWeight={fontWeight.Weight[3]}
                    color={colors.fonts[25]}
                    sx={{ mb: 2 }}>
                    A copy of our Notice of Privacy Practices is provided{" "}
                    <Link href={privacyPracticeUrl} target="_blank" rel="noopener noreferrer" color="primary">
                            here
                        </Link>
                    .
                    </Typography>
                </Grid>
                <Grid container sx={ContentBoxHeader} justifyContent="center" alignItems="center">
                    <Button
                        sx={CreateBtn}
                        variant="contained"
                        onClick={handleClick}
                    >
                        Yes, I Agree
                    </Button>
                </Grid>
            </Box>
        </Modal>
    );
};
export default PrivacyModal;